import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../../queryKeys";
import { ClassEventService } from "../../../services/class-event.service";

export const useGetClassEventReservationByIdQuery = ({
  classEventId,
  gymListingId,
}: {
  classEventId: number | null;
  gymListingId: string | null;
}) => {
  return useQuery<any, Error>({
    queryKey: [QUERY_CONSTANTS.GET_CLASS_EVENT_RESERVATION_BY_ID, classEventId, gymListingId],
    queryFn: () =>
      ClassEventService.getClassEventReservationById(classEventId, gymListingId).then(
        (res) => res.data
      ),
    enabled: !!classEventId && !!gymListingId,
  });
};
